import { ActionIcon, type ActionIconProps, type PolymorphicComponentProps } from '@mantine/core';
import { IconPrinter } from '@tabler/icons-react';
import * as React from 'react';

type ActionIconButtonProps = PolymorphicComponentProps<'button', ActionIconProps>;

type PrintActionButtonProps = Omit<ActionIconButtonProps, 'children'> & {
  iconSize?: number;
};

const PrintActionButton: React.FC<PrintActionButtonProps> = ({ iconSize = 20, ...actionIconProps }) => {
  return (
    <ActionIcon {...actionIconProps}>
      <IconPrinter size={iconSize} />
    </ActionIcon>
  );
};

export default React.memo(PrintActionButton);
